import React from 'react';
import CreateCourse from './create';

const CreateCoursePage = () => {
  return <CreateCourse />;
};

export default CreateCoursePage;